import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Clients } from "@/lib/clients";
import { exportStatusLabels } from "../../../components/Badge";

const filterDowloadCenterSchema = z.object({
  client_contains: z.string().optional(),
  user_contains: z.string().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  report_date_from: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  report_date_to: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  file_name_contains: z.string().optional(),
  status_in: z.string().optional(),
});

const filterDowloadCenterFields = filterDowloadCenterSchema.keyof().enum;

export type FilterDowloadCenterSchemaType = z.infer<
  typeof filterDowloadCenterSchema
>;

export function FilterDowloadCenter() {
  const { t } = useTranslation();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: filterDowloadCenterFields.client_contains,
        label: "Client",
        type: "input",
      },
      {
        name: filterDowloadCenterFields.user_contains,
        label: t("download_center.columns.user_name", {
          defaultValue: "Utilisateur",
        }),
        type: "input",
      },
      {
        name: filterDowloadCenterFields.file_name_contains,
        label: t("download_center.columns.file_name", {
          defaultValue: "Nom du fichier",
        }),
        type: "input",
      },
      {
        name: filterDowloadCenterFields.status_in,
        label: t("download_center.columns.status", { defaultValue: "Statut" }),
        type: "select",
        useTranslation: false,
        options: exportStatusLabels(t),
      },
      {
        name: "created_at",
        type: "dateRange",
        label: t("download_center.columns.created_at", {
          defaultValue: "Date de génération",
        }),
        from: { name: filterDowloadCenterFields.created_at_from },
        to: { name: filterDowloadCenterFields.created_at_to },
      },
      {
        name: "report_date",
        type: "dateRange",
        label: t("download_center.columns.reporting_date", {
          defaultValue: "Date du rapport",
        }),
        from: { name: filterDowloadCenterFields.report_date_from },
        to: { name: filterDowloadCenterFields.report_date_to },
      },
    ],
    [t],
  );
  return (
    <FilterTable
      schema={filterDowloadCenterSchema}
      client={Clients.E2}
      tableName={`${Clients.E2}_download_center`}
      fields={fields}
    />
  );
}
